import React from "react";
import Image from "react-bootstrap/Image";
import {
  ReusableOnboardingLink,
  ReusableOnboardingButton,
} from "../../reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";
import RightSidePannel from "../rightSidePannelReusable/RightSidePannel";

export const BankAndOtherDetailsHome = ({ onClick }) => {
  return (
    <React.Fragment>
      <div className="bank_and_other_details_onboarding_main">
        <div className="bank_and_other_details_onboarding_homescreen">
          <div className="display-toggle-stepup-button">
            <RightSidePannel selectedTab={4} />
          </div>
          <h3 className="bank_and_other_details_onboarding-heading-text-big">
            Store Setup
          </h3>
          <hr />
          <h4
            className="f18_500_HelveticaNeue mb-2"
            style={{ fontWeight: "700" }}
          >
            Bank and Other Details
          </h4>
          <Image
            className="image-bank-home"
            src={require("../../../../assets/images/onboarding/storeSetup5.png")}
            alt="bank"
            title="bank"
            fluid
          />
          <div className="col-12 d-flex justify-content-center">
            <p className="paragraph-text-bank-home">
              Please provide proper information for Bank Account and Other
              Relevant Information. Also upload Copies of the document fo
              verification and KYC
            </p>
          </div>
          <div className="onboarding-map-setup-screen-autodetect-button mt-5 justify-content-center">
            {/* <div className="onboarding-map-setup-screen-autodetect-button-inside"> */}
            <ReusableOnboardingLink
              buttonTitle="Back Button"
              buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_white mr-3"
              buttonText="Back"
              link="/businessHours"
            />
            <ReusableOnboardingButton
              buttonTitle="Next Button"
              buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_red ml-3"
              buttonText="Next"
              onClick={onClick}
            />
            {/* </div> */}
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};
//update
